import React from "react";
import { Grid, Typography, Box, CircularProgress, Stack } from "@mui/material";
import { formatMoney } from "../../pipes/PriceFormatter";

interface OrderSummarySectionProps {
    order?: any;
    subtotal: number;
    serviceChargeTotal: number;
    gratuityTotal: number;
    totalTax: number;
    deliveryFee: number;
    discountTotal: number;
    total: number;
    calculatePaymentLoading: boolean;
    orderType?: string;
    organizationSettings: any;
    classes: any;
}

const OrderSummarySection: React.FC<OrderSummarySectionProps> = ({
    order,
    subtotal,
    serviceChargeTotal,
    gratuityTotal,
    totalTax,
    deliveryFee,
    discountTotal,
    total,
    calculatePaymentLoading,
    orderType,
    organizationSettings,
    classes,
}) => {
    return (
        <>
            <Grid item={true} xs={12} sm={12}>
                <Box
                    sx={{
                        marginTop: "20px",
                        marginBottom: "10px",
                        fontSize: "18px",
                        fontWeight: 600,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { sm: "16px" },
                            fontWeight: 600,
                            marginBottom: "5px",
                        }}
                    >
                        Payment
                    </Typography>
                </Box>
                <Grid
                    container={true}
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "white",
                        padding: "10px 15px",
                        borderRadius: "12px",
                        mb: "20px",
                    }}
                >
                    {!!order.orderEventDetails &&
                        !!order.orderEventDetails.banquetRoomRate && (
                            <>
                                <Grid item={true} xs={12} sm={6}>
                                    <Typography
                                        sx={{ fontSize: { sm: "16px" } }}
                                        className={classes.marginBottom5}
                                    >
                                        Room Rate:
                                    </Typography>
                                </Grid>
                                <Grid item={true} xs={12} sm={2} md={6}>
                                    <Typography
                                        sx={{
                                            fontSize: {
                                                sm: "16px",
                                                textAlign: "right",
                                            },
                                            fontWeight: 500,
                                            color: organizationSettings?.layoutColor,
                                        }}
                                    >
                                        $
                                        {formatMoney(
                                            order.orderEventDetails.banquetRoomRate
                                        )}
                                    </Typography>
                                </Grid>
                            </>
                        )}
                    <Grid item={true} xs={12} sm={6}>
                        <Typography
                            sx={{ fontSize: { sm: "16px" } }}
                            className={classes.marginBottom5}
                        >
                            Items subtotal:
                        </Typography>
                    </Grid>
                    <Grid item={true} xs={12} sm={2} md={6}>
                        <Typography
                            sx={{
                                fontSize: {
                                    sm: "16px",
                                    textAlign: "right",
                                },
                                fontWeight: 500,
                                color: organizationSettings?.layoutColor,
                            }}
                        >
                            {calculatePaymentLoading ? (
                                <CircularProgress color="secondary" size={20} />
                            ) : (
                                "$" + formatMoney(subtotal)
                            )}
                        </Typography>
                    </Grid>
                    <Grid item={true} xs={12} sm={6}>
                        <Typography
                            sx={{ fontSize: { sm: "16px" } }}
                            className={classes.marginBottom5}
                        >
                            Service Charge:
                        </Typography>
                    </Grid>
                    <Grid item={true} xs={12} sm={2} md={6}>
                        <Typography
                            sx={{
                                fontSize: {
                                    sm: "16px",
                                    textAlign: "right",
                                },
                                fontWeight: 500,
                                color: organizationSettings?.layoutColor,
                            }}
                        >
                            {calculatePaymentLoading ? (
                                <CircularProgress color="secondary" size={20} />
                            ) : (
                                "$" + formatMoney(serviceChargeTotal)
                            )}
                        </Typography>
                    </Grid>
                    {!!order.gratuity && (
                        <>
                            <Grid item={true} xs={12} sm={6}>
                                <Typography
                                    sx={{ fontSize: { sm: "16px" } }}
                                    className={classes.marginBottom5}
                                >
                                    Gratuity:
                                </Typography>
                            </Grid>
                            <Grid item={true} xs={12} sm={2} md={6}>
                                <Typography
                                    sx={{
                                        fontSize: {
                                            sm: "16px",
                                            textAlign: "right",
                                            fontWeight: 500,
                                            color: organizationSettings?.layoutColor,
                                        },
                                    }}
                                >
                                    ${formatMoney(order.gratuity)}
                                </Typography>
                            </Grid>
                        </>
                    )}
                    <Grid item={true} xs={12} sm={6}>
                        <Typography
                            sx={{ fontSize: { sm: "16px" } }}
                            className={classes.marginBottom5}
                        >
                            Tax:
                        </Typography>
                    </Grid>
                    <Grid item={true} xs={12} sm={2} md={6}>
                        <Typography
                            sx={{
                                fontSize: {
                                    sm: "16px",
                                    textAlign: "right",
                                },
                                fontWeight: 500,
                                color: organizationSettings?.layoutColor,
                            }}
                        >
                            {calculatePaymentLoading ? (
                                <CircularProgress color="secondary" size={20} />
                            ) : (
                                "$" + formatMoney(totalTax)
                            )}
                        </Typography>
                    </Grid>
                    {gratuityTotal !== 0 && (
                        <>
                            <Grid item={true} xs={12} sm={6}>
                                <Typography
                                    sx={{ fontSize: { sm: "16px" } }}
                                    className={classes.marginBottom5}
                                >
                                    Gratuity:
                                </Typography>
                            </Grid>
                            <Grid item={true} xs={12} sm={2} md={6}>
                                <Typography
                                    sx={{
                                        fontSize: {
                                            sm: "16px",
                                            textAlign: "right",
                                            fontWeight: 500,
                                            color: organizationSettings?.layoutColor,
                                        },
                                    }}
                                >
                                    {calculatePaymentLoading ? (
                                        <CircularProgress color="secondary" size={20} />
                                    ) : (
                                        "$" + formatMoney(gratuityTotal)
                                    )}
                                </Typography>
                            </Grid>
                        </>
                    )}
                    {orderType === "Delivery" && (
                        <>
                            <Grid item={true} xs={12} sm={6}>
                                <Typography
                                    sx={{ fontSize: { sm: "16px" } }}
                                    className={classes.marginBottom5}
                                >
                                    Delivery Fee:
                                </Typography>
                            </Grid>
                            <Grid item={true} xs={12} sm={2} md={6}>
                                <Typography
                                    sx={{
                                        fontSize: {
                                            sm: "16px",
                                            textAlign: "right",
                                            fontWeight: 500,
                                            color: organizationSettings?.layoutColor,
                                        },
                                    }}
                                >
                                    {calculatePaymentLoading ? (
                                        <CircularProgress color="secondary" size={20} />
                                    ) : (
                                        "$" + formatMoney(deliveryFee || 0)
                                    )}
                                </Typography>
                            </Grid>
                        </>
                    )}
                    {discountTotal !== 0 && (
                        <>
                            {" "}
                            <Grid item={true} xs={12} sm={6}>
                                <Typography
                                    sx={{ fontSize: { sm: "16px" } }}
                                    className={classes.marginBottom5}
                                >
                                    Discount Total:
                                </Typography>
                            </Grid>
                            <Grid item={true} xs={12} sm={2} md={6}>
                                <Typography
                                    sx={{
                                        fontSize: {
                                            sm: "16px",
                                            textAlign: "right",
                                            fontWeight: 500,
                                            color: organizationSettings?.layoutColor,
                                        },
                                    }}
                                >
                                    {calculatePaymentLoading ? (
                                        <CircularProgress color="secondary" size={20} />
                                    ) : (
                                        "$-" + formatMoney(discountTotal)
                                    )}
                                </Typography>
                            </Grid>
                        </>
                    )}
                    <Grid item={true} xs={12} sm={6}>
                        <Typography
                            sx={{
                                fontSize: { sm: "16px", fontWeight: 600 },
                            }}
                            className={classes.marginBottom5}
                        >
                            Total:
                        </Typography>
                    </Grid>
                    <Grid item={true} xs={12} sm={2} md={6}>
                        <Typography
                            sx={{
                                fontSize: {
                                    sm: "16px",
                                    fontWeight: 600,
                                    textAlign: "right",
                                },
                                color: organizationSettings?.layoutColor,
                            }}
                        >
                            {calculatePaymentLoading ? (
                                <CircularProgress size={20} />
                            ) : (
                                "$" + formatMoney(total)
                            )}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default OrderSummarySection;
